import DevelopmentPlan from 'development-plan/components/DevelopmentPlan';
import QuestionDisplay from '../questions/Question';
import Goals from 'development-plan/components/Goals';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';

export default function DevelopmentPlanItem({
	item,
	participants,
}: {
	item: graphql.DevelopmentPlanItem;
	participants: graphql.Participant[];
}) {
	const { t } = useTranslation();

	const userID = participants.find(
		(participant) => participant.role === graphql.ConversationRole.Requester,
	)!.user.id;

	const query = graphql.useDevelopmentPlanQuery({
		variables: { userID },
	});

	return (
		<QuestionDisplay title={t('evaluation.submission.developmentPlan.title')} number={item.number}>
			{query.loading && <DevelopmentPlan.Skeleton />}
			{query.data?.user && (
				<Goals
					onSave={() => {
						query.refetch();
					}}
					user={query.data.user}
				/>
			)}
		</QuestionDisplay>
	);
}
